import React from 'react';
import { Create, SimpleForm, TextInput, useNotify, Toolbar, ListButton, SaveButton } from 'react-admin';

import { ContentWriterKeywordStatusSelectInput } from '../../UI/Input/SelectInput'
import { onContentWriterKeywordAmountCreate } from '../../Service/Validation/ContentWriterKeywordAmountValidation'
import Grid from '@material-ui/core/Grid';

const PageTitle = () => {
    return <span>Create content writer keyword amount</span>;
};

const FormToolbar = props => (
    <Toolbar {...props} >
        <SaveButton label="Save" redirect="show" submitOnEnter={true} />
        {!props.saving && <ListButton label="Cancel" />}
    </Toolbar>
)
const SanitizedGrid = ({ basePath, ...props }) => {
    return (
        <Grid {...props} />
    );
};

const ContentWriterKeywordAmountCreate = (props) => {
    const notify = useNotify();

    const onError = (error) => {
        var errorArr = [];
        Object.keys(error.body.errors).forEach(function (key) {
            errorArr.push(error.body.errors[key])
        });
        notify(`Could not create item: ${errorArr.toString()}`, { type: 'error' });
    };
    return (
        <Create title={<PageTitle />} {...props} undoable={false} mutationOptions={{ onError }}>
            <SimpleForm toolbar={<FormToolbar />} warnWhenUnsavedChanges validate={onContentWriterKeywordAmountCreate}>
                <SanitizedGrid container spacing={3} fullWidth>
                    <Grid item sm={12} md={4} lg={4}>
                        <TextInput label="Keyword Count" source="keyword_count" fullWidth />
                    </Grid>
                    <Grid item sm={12} md={4} lg={4}>

                        <TextInput label="Sales Team Amount" source="sales_amount" fullWidth />
                    </Grid>
                    <Grid item sm={12} md={4} lg={4}>
                        <TextInput label="Promotion Team Amount" source="promotion_amount" fullWidth />
                    </Grid>

                </SanitizedGrid>
                <SanitizedGrid container spacing={3} fullWidth>
                    <Grid item sm={12} md={12} lg={12}>
                        <TextInput label="Amount" source="amount" fullWidth />
                    </Grid>

                </SanitizedGrid>
            </SimpleForm>
        </Create>
    );
}
export default ContentWriterKeywordAmountCreate